// Sistema de logging condicional con fallback de seguridad
// - En producción: console.log/debug/info/table/group se vuelven no-op
//   (compatibilidad con logs antiguos que quedaron en el código)
// - En desarrollo + preview: todo se muestra (útil para debugging remoto)
// - console.warn y console.error NUNCA se silencian (los errores reales deben verse)

const isDevelopment =
  process.env.NODE_ENV === 'development' ||
  (typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname.includes('preview')));

// API recomendada — usar `import logger from '@/utils/logger'`
export const logger = {
  log: (...args) => {
    if (isDevelopment) console.log(...args);
  },
  debug: (...args) => {
    if (isDevelopment) console.log('[DEBUG]', ...args);
  },
  info: (...args) => {
    if (isDevelopment) console.log('[INFO]', ...args);
  },
  warn: (...args) => {
    console.warn('[WARN]', ...args);
  },
  error: (...args) => {
    console.error('[ERROR]', ...args);
  },
  // Para eventos importantes que queremos ver siempre
  important: (...args) => {
    console.log('✨', ...args);
  },
};

// Safety net: sobrescribir console.* globalmente en producción.
// Cubre cualquier console.log legacy que no haya migrado a `logger`.
if (typeof window !== 'undefined' && !isDevelopment) {
  const noop = () => {};

  // Guardar originales por si algún componente los necesita explícitamente
  window.__originalConsole = {
    log: console.log,
    debug: console.debug,
    info: console.info,
    table: console.table,
    group: console.group,
    groupEnd: console.groupEnd,
    time: console.time,
    timeEnd: console.timeEnd,
  };

  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.table = noop;
  console.group = noop;
  console.groupEnd = noop;
  console.time = noop;
  console.timeEnd = noop;

  // console.warn y console.error se preservan intencionadamente
}

export default logger;
